import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { Appointment, Schedule } from '../../appointment/model/appointment';
import { AppointmentService } from '../../appointment/service/appointment.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { UserService } from 'app/section/user/service/user.service';
@Component({
  selector: 'app-missed',
  templateUrl: './missed.component.html'
})
export class MissedComponent implements OnInit {
 
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  appointments : Appointment[];
  selectedAppObject : Appointment;
  isSuccessMessage : boolean = false;
  isErrorMessage : boolean = false;
  apploading : boolean = false;
  isAdd : boolean = true;
  userClinic= null;
  appDate: any;
  id: number;
  private sub: any;
  user : any ; 
  constructor(private _sharedService: SharedService,private _appService : AppointmentService, private _usrService : UserService) {  }


  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    if(this.user=== undefined || this.user=== null) {
      this.getUserDetail('');
    }
    this.getMissedAppointment();
  }
  getMissedAppointment() : void {
    this.apploading = true;
     this._appService.getAllMissedAppointment('','').subscribe(data=>{
       this.appointments = data;
       this.apploading = false;
     },error=>{

     });
  }
  getUserDetail(startDate: string) {
    this._usrService.getUserProfile().subscribe(data=>{
       if(data.length>0) {
       
        this.user = data[0];
        sessionStorage.setItem("User",JSON.stringify(data[0]));
        
      }
      
    },error => {
       
    })
  }

   
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/missed/missed.component.ts